"use client";

import { ImageList } from "@/composite/ImageList";
import { ImageListReference } from "@/types";

type ImageListBlockProps = Partial<ImageListReference>;

/**
 * Image List block component
 */
export function ImageListBlock({
	headline,
	image_list
}: ImageListBlockProps): JSX.Element {
	return (
		<ImageList
			headline={headline?.headline}
			headlineTag={headline?.headline_tag}
			images={
				image_list?.map((image) => ({
					imageSrc: image.image,
					headline: image.title.headline,
					headlineTag: image.title.headline_tag,
					description: image.description
				})) ?? []
			}
		/>
	);
}
